//QUICK VIEW CART MODAL UPDATE

class QuickViewModal extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.productHandle = "";
    this.quickBuyButtons = document.querySelectorAll(
      "a[data-button-quick-view]"
    );

    this.assignEventButtons();
    this.render();
    this.addEventListeners();
  }

  // assignEventButtons() {
  //   this.quickBuyButtons.forEach((button) => {
  //     button.addEventListener("click", (event) => {
  //       event.preventDefault();
  //       event.stopPropagation();
  //       event.stopImmediatePropagation();

  //       const handle = button.getAttribute("data-handle");
  //       this.open(handle);
  //     });
  //   });
  // }

  assignEventButtons() {
    document.addEventListener("click", (event) => {
      const button = event.target.closest("a[data-button-quick-view]");
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const handle = button.getAttribute("data-handle");
      this.open(handle);
    });
  }

  render() {
    this.innerHTML = `
      <div class="quick-view-overlay" id="quick-view-overlay">
        <div class="quick-view-modal-wrapper">
            <button class="quick-view-close-button" id="quick-view-close-button">&times;</button>
            <div class="quick-view-modal-content" id="quick-view-modal-content">
                <div class="quick-view-loading"></div>
            </div>
        </div>
      </div>
    `;
  }

  addEventListeners() {
    const closeButton = this.querySelector("#quick-view-close-button");
    closeButton.addEventListener("click", () => this.close());

    const overlay = this.querySelector("#quick-view-overlay");
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) {
        this.close();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.isOpen) {
        this.close();
      }
    });

    document.addEventListener("click", (event) => {
      const button = event.target.closest("[handle]");
      if (button) {
        const handle = button.getAttribute("handle");
        if (handle) {
          event.preventDefault();
          this.open(handle);
        }
      }
    });
  }

  open(handle) {
    if (!handle) return;

    this.productHandle = handle;
    this.isOpen = true;

    const overlay = this.querySelector("#quick-view-overlay");
    overlay.classList.add("active");

    document.body.style.overflow = "hidden";

    this.loadProductContent();
    this.onModalOpened();
  }

  openWithEvent(event) {
    const parent = event.target.closest(".btn--quick");
    if (!parent) return;

    const handle = parent.getAttribute("data-handle");
    this.open(handle);
  }

  close() {
    this.isOpen = false;
    const overlay = this.querySelector("#quick-view-overlay");
    overlay && overlay.classList.remove("active");
    document.body.style.overflow = "";
    document.dispatchEvent(
      new CustomEvent("theme:quick-view:close", {
        detail: {},
        bubbles: true,
      })
    );
  }

  async loadProductContent() {
    const modalContent = this.querySelector(".quick-view-modal-wrapper");
    try {
      modalContent.innerHTML = '<div class="quick-view-loading"></div>';
      const response = await fetch(`/products/${this.productHandle}?section_id=api-quickview`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const html = await response.text();
      modalContent.innerHTML = html;

      this.lastClickedHandle = this.productHandle;

      const swatchToActivate = this.querySelector(
        `a[data-swatch][product-handle="${this.lastClickedHandle}"]`
      );
      if (swatchToActivate) {
        swatchToActivate.classList.add("is-active");
      }

      if (typeof Drawer === 'function') {
        new Drawer(document);
      }

      const productJsonEl = modalContent.querySelector('[data-product-json]');
      if (!productJsonEl) {
        console.error('Quick view: Missing product JSON');
        return;
      }

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        console.error('Quick View: Invalid product JSON format', e);
        return;
      }

      if (this.atsInventoryMap) {
        productData.variants.forEach((variant) => {
          const atsQty = this.atsInventoryMap[variant.id];
          if (typeof atsQty === 'number') {
            variant.available = atsQty > 0;
          }
        });

        // Update product JSON back into DOM
        productJsonEl.textContent = JSON.stringify(productData);
      }

      const variantIds = productData.variants.map((v) => v.id).join(',');

      // ✅ ATS fetch and logic
      if (window.isPro === true || document.body.getAttribute('data-pro') === 'true') {
        fetch(`https://api.geostock.app/shop/toadandco.myshopify.com/multi_variant_locations/${variantIds}`)
          .then((res) => res.json())
          .then((atsData) => {
            this.atsInventoryMap = {};

            productData.variants.forEach((variant) => {
              const ats = atsData[variant.id]?.locations?.find(loc => loc.name === "ATS");
              const stockQty = ats?.stock ?? 0;
              this.atsInventoryMap[variant.id] = stockQty;

              const inputSelectors = modalContent.querySelectorAll('[data-single-option-selector]');

              if (!inputSelectors.length) {
                console.warn('[QuickViewModal] No variant inputs found.');
                return;
              }

              inputSelectors.forEach((input) => {
                const indexAttr = input.dataset.index;
                if (!indexAttr || !indexAttr.includes('option')) return;

                const index = parseInt(indexAttr.replace('option', ''), 10) - 1;
                const value = input.value;

                if (variant.options && variant.options[index] === value) {
                  const radioButton = input.closest('.radio__button');
                  if (radioButton) {
                    if (stockQty <= 0) {
                      radioButton.classList.add('sold-out');
                    } else {
                      radioButton.classList.remove('sold-out');
                    }
                  }
                }
              });
            });

          })
          .then(() => {
            this.initProductFunctionality();

            // Delay Flickity init to fix stacked images issue
            setTimeout(() => {
              this.initFlickity();
            }, 50);
          })
          .catch((error) => {
            console.error("Error fetching ATS stock for quick view:", error);
            // 🔥 Set all variants to unavailable as fallback
            productData.variants.forEach((variant) => {
              variant.available = false;
            });
            productJsonEl.textContent = JSON.stringify(productData);
            this.updateSelectedVariant();
          });
      } else {
        this.initProductFunctionality();
        setTimeout(() => {
          this.initFlickity();
        }, 50);
      }

    } catch (error) {
      console.error("Error loading product content:", error);
      modalContent.innerHTML = `<div style="text-align: center; padding: 20px;">
        <p>Sorry, we couldn’t load the product content.</p>
        <p>Please try again later.</p>
      </div>`;
    }
  }


  onModalOpened() {
    setTimeout(() => {
      const container = document.querySelector('.popup-quick-view__body');
      if (!container) return;

      const fieldset = container.querySelector('fieldset.siblings');
      const activeSwatch = fieldset?.querySelector('a.is-active');
      const swatchValue = activeSwatch?.dataset?.swatch;

      const label = container.querySelector('#quickview-modal-color-name');

      if (label && swatchValue) {
        label.textContent = swatchValue;
      }

    }, 800);
  }

  resetContent() {
    const modalContent = this.querySelector("#quick-view-modal-content");
    if (modalContent) {
      modalContent.innerHTML = '<div class="quick-view-loading"></div>';
    }
    this.productHandle = "";
  }

  initProductFunctionality() {
    const closeButton = this.querySelector(".popup-quick-view__close");
    closeButton?.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });

    this.initFlickity();
    this.initSwatches();
    this.addEventsToInputs();
    this.assignSubmitEventToAddToCart();
    this.checkPrices();
    this.updateSelectedVariant();
    this.addSizeChartToggleListener();
  }

  assignSubmitEventToAddToCart() {
    // Bind ONCE per modal lifetime
    if (this.__delegatedSubmitHandlerBound) return;
    this.__delegatedSubmitHandlerBound = true;

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.btn--submit');
      if (!btn) return;

      const form = this.querySelector('form[action="/cart/add"]');
      if (!form) return;

      // CLICK LOCK
      if (btn.dataset.notifyClickLock === 'true') return;
      btn.dataset.notifyClickLock = 'true';
      setTimeout(() => {
        btn.dataset.notifyClickLock = 'false';
      }, 800);

      const hasNotificationPopup = btn.hasAttribute('data-bis-notification-popup');

      // SOLD OUT / NOTIFY ME
      if (hasNotificationPopup) {
        e.preventDefault();
        e.stopPropagation();

        return;
      }

      // AJAX Add to Cart
      e.preventDefault();
      e.stopPropagation();

      // Gather form data
      const formData = new FormData(form);
      btn.classList.add('loading');
      btn.disabled = true;
      

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          btn.classList.remove('loading');
          btn.disabled = false;
          // Optionally show success feedback
          // Always open the cart drawer modal after successful add
          if (typeof window.TC_openCartDrawer === 'function') {
            window.TC_openCartDrawer();
            // Close quick view modal after opening cart drawer
            this.close();
          } else if (window.cartDrawer && typeof window.cartDrawer.updateCart === 'function') {
            window.cartDrawer.updateCart();
            if (typeof window.cartDrawer.refreshDrawer === 'function') {
              window.cartDrawer.refreshDrawer();
            }
            this.close();
          }
          // Optionally close modal
          // this.close();
        })
        .catch(error => {
          btn.classList.remove('loading');
          btn.disabled = false;
          // Optionally show error feedback
          alert('Could not add to cart. Please try again.');
        });
    });

    // Intercept form submit to use cart drawer (avoid redirect to cart page)
    this.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();

      const submitBtn = form.querySelector('.btn--submit');
      if (submitBtn?.hasAttribute('data-notification-popup')) {
        return;
      }

      const formData = new FormData(form);

      if (window.cartDrawer && typeof window.cartDrawer.addToCart === 'function') {
        window.cartDrawer.button = submitBtn;
        window.cartDrawer.form = form;
        // Ensure form wrapper is set for loading/error states
        window.cartDrawer.formWrapper = submitBtn?.closest('[data-form-wrapper]') || submitBtn?.closest('form');

        // If variant id is missing, abort
        if (!formData.get('id')) {
          console.warn('[QuickView] Missing variant id for add to cart');
          return;
        }

        window.cartDrawer.addToCart(formData);
        // Give the add-to-cart request a moment, then open/refresh drawer
        setTimeout(() => {
          window.cartDrawer.getCart?.();
          window.cartDrawer.openCartDrawer?.();
        }, 250);

        this.close();
        return;
      }

      // Fallback: AJAX add + open drawer if available
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: formData.get('id'), quantity: formData.get('quantity') || 1 })
      })
        .then(() => {
          if (window.cartDrawer?.refreshDrawer) window.cartDrawer.refreshDrawer();
          this.close();
        })
        .catch((err) => console.error('[QuickView] add to cart failed', err));
    });
  }


  checkPrices() {
    const priceWrapper = this.querySelector('.product__price[data-price-wrapper]');
    if (!priceWrapper) return;
    const regularPriceEl = priceWrapper.querySelector('[data-product-price]');
    const comparePriceEl = priceWrapper.querySelector('[data-compare-price]');
    if (regularPriceEl && comparePriceEl && regularPriceEl.textContent.trim() === comparePriceEl.textContent.trim()) {
      comparePriceEl.classList.add('hidden');
    }
  }

  addEventsToInputs() {
    const inputs = this.querySelectorAll("input[type='radio'], input[type='checkbox'], select");
    inputs.forEach((input) => {
      input.addEventListener("change", () => this.updateSelectedVariant());
    });
  }

  updateSelectedVariant() {
    const form = this.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const options = [];
    form.querySelectorAll('[data-single-option-selector]').forEach((el) => {
      const value = el.type === 'radio' ? (el.checked ? el.value : null) : el.value;
      if (value !== null) options.push(value);
    });

    const productJson = this.querySelector('[data-product-json]');
    if (!productJson) return;
    const product = JSON.parse(productJson.textContent);

    const matchedVariant = product.variants.find((variant) =>
      variant.options.every((opt, idx) => opt === options[idx])
    );
    if (!matchedVariant) return;


    const atcButton = form.querySelector('.btn--submit');
    const ctaTextEl = this.querySelector('[data-add-to-cart-text]');

    if (!atcButton || !ctaTextEl) return;

    const showBISModal = atcButton.hasAttribute('data-show-bis');

    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = matchedVariant.id;

    document.dispatchEvent(
      new CustomEvent("theme:quick-view-variant:change", {
        detail: {
          variant: matchedVariant,
        },
        bubbles: true,
      })
    );

    // ✅ Check ATS override for Pro users
    if ((window.isPro || document.body.getAttribute('data-pro') === 'true') && this.atsInventoryMap) {
      const atsStock = this.atsInventoryMap[matchedVariant.id];
      if (typeof atsStock === 'number') {
        matchedVariant.available = atsStock > 0;
        //console.log(`[QuickViewModal] Pro user - ATS stock for variant ${matchedVariant.id}: ${atsStock}`);
      }
    }

    if (matchedVariant.available) {
      // In stock
      ctaTextEl.textContent = 'Add to Cart';
      atcButton.disabled = false;
      atcButton.type = 'submit';
      atcButton.classList.remove('btn--primary', 'btn--solid', 'open-modal-button');

      atcButton.innerHTML = `
        <span data-add-to-cart-text="">Add to Cart</span>
        <em class="loader loader--line"><em class="loader-indeterminate"></em></em>
      `;

      if (showBISModal) {
        atcButton.removeAttribute('data-bis-notification-popup');
      }
    } else {
      // Sold out
      ctaTextEl.textContent = 'Sold Out - Notify Me';
      atcButton.disabled = false;
      atcButton.type = 'button';
      atcButton.classList.add('btn--primary', 'btn--solid', 'open-modal-button');
      // ✅ Add the notification form markup
      atcButton.innerHTML = `
        <span data-add-to-cart-text="">Sold Out - Notify Me</span>
        <em class="loader loader--line"><em class="loader-indeterminate"></em></em>
      `;
      if (showBISModal) {
        atcButton.setAttribute('data-bis-notification-popup', true);
      }

      // ✅ Re-query the new submit button after updating innerHTML
      this.submitButton = this.querySelector('.btn--submit');
    }

    const quickViewItem = this.querySelector('.popup-quick-view__item');
    if (quickViewItem) {
      if (!matchedVariant.available) {
        quickViewItem.classList.add('variant--soldout');
      } else {
        quickViewItem.classList.remove('variant--soldout');
      }
    }

    this.markSoldOutVariants(product);
  }



  buildNotificationMarkup(variant) {
    const productTitle = this.querySelector('.product__title')?.textContent || 'Product';
    const optionTitle = variant.title || '';
    return `
      <div class='product__notification' data-notification>
        <h2 class='product__notification__title'>${productTitle}</h2>
        <p class='product__notification__subtitle'>${optionTitle}</p>
        <form method='post' action='/contact#NotificationForm-${variant.id}' id='NotificationForm-${variant.id}' accept-charset='UTF-8' class='contact-form' data-notification-form>
          <input type='hidden' name='form_type' value='customer' />
          <input type='hidden' name='utf8' value='✓' />
          <div class='product__notification__message'>
            <p>Your email has been received.</p>
          </div>
          <div class='product__notification__form'>
            <label for='Email-${variant.id}'>Please enter your email and we will let you know when your selected item becomes available.</label>
            <input type='hidden' name='contact[tags]' value='newsletter, out-of-stock-notification--${productTitle}'/>
            <input type='hidden' name='contact[first_name]' value='Newsletter' />
            <input type='hidden' name='contact[last_name]' value='Subscriber' />
            <div class='input-group input-group--inline'>
              <div class='input-group__item'>
                <input type='email' placeholder='Your email' name='contact[email]' id='Email-${variant.id}' class='input-group__field input-group__field--email' aria-label='Your email' autocorrect='off' autocapitalize='off' required data-popup-input>
              </div>
              <div class='input-group__item--btn'>
                <button type='submit' name='subscribe' id='SubscribeSubmit-${variant.id}' class='btn btn--primary btn--solid'>
                  <span data-notification-button-text>Notify Me</span>
                </button>
              </div>
            </div>
          </div>
        </form>
        <button title='Close (Esc)' class='product__notification__close' data-popup-close>
          <svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-close' viewBox='0 0 192 192'><path d='M150 42 42 150M150 150 42 42' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'/></svg>
        </button>
      </div>
    `.trim();
  }

  showNotificationPopup(content) {
    const popupWrapper = document.createElement('div');
    popupWrapper.innerHTML = content;
    const popup = popupWrapper.firstElementChild;
    document.body.appendChild(popup);

    // Optional: Add fade-in animation or focus management
    popup.querySelector('[data-popup-close]')?.addEventListener('click', () => popup.remove());
  }

  addSizeChartToggleListener() {
    const sizeChartButton = this.querySelector('[data-drawer-toggle][aria-controls^="size-chart"]');
    if (!sizeChartButton) return;
  
    sizeChartButton.addEventListener('click', (e) => {
      e.preventDefault();
  
      const drawerId = sizeChartButton.getAttribute('aria-controls');
      const drawer = document.getElementById(drawerId);
      if (!drawer) return;
  
      // Open drawer
      drawer.classList.add('alt', 'is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('tabindex', '-1');
      sizeChartButton.setAttribute('aria-expanded', 'true');
  
      // Lock scroll
      document.dispatchEvent(
        new CustomEvent('theme:scroll:lock', {
          bubbles: true,
          detail: drawer,
        })
      );
  
      // ✅ Close button logic
      const closeButton = drawer.querySelector('[data-drawer-toggle]');
      if (closeButton) {
        closeButton.addEventListener('click', (ev) => {
          ev.preventDefault();
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.removeAttribute('tabindex');
          sizeChartButton.setAttribute('aria-expanded', 'false');
  
          // Unlock scroll
          document.dispatchEvent(
            new CustomEvent('theme:scroll:unlock', { bubbles: true })
          );
        });
      }
  
      // Optional: trap focus
      if (typeof Drawer === 'function') {
        new Drawer(document);
      }
    });
  }
  
  

  markSoldOutVariants(product) {
    const inputs = this.querySelectorAll('[data-single-option-selector]');
    inputs.forEach((input) => {
      const value = input.value;
      const optionIndex = parseInt(input.getAttribute("data-index").replace("option", "")) - 1;
      const available = product.variants.some(variant => variant.options[optionIndex] === value && variant.available);
      const label = this.querySelector(`label[for="${input.id}"]`);
      if (label) label.classList.toggle("sold-out", !available);
    });
  }

  initSwatches() {
    const swatches = this.querySelectorAll("a[data-swatch]");
    if (!swatches.length) return;
    swatches.forEach((swatch) => {
      swatch.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const selectedHandle = swatch.getAttribute("product-handle");
        this.open(selectedHandle);
      });
    });
  }

  initFlickity() {
    const slider = this.querySelector("[data-product-single-media-slider]");
    if (slider) {
      try {
        this.flickity = new themeVendor.Flickity(slider, {
          draggable: true,
          contain: true,
          wrapAround: true,
          cellAlign: "left",
          pageDots: false,
          prevNextButtons: true,
          adaptiveHeight: false
        });

        if (typeof imagesLoaded === "function") {
          imagesLoaded(slider, () => this.flickity?.resize());
        } else {
          slider.querySelectorAll("img").forEach((img) => {
            img.onload = () => this.flickity?.resize();
          });
        }
      } catch (error) {
        console.error("Error initializing Flickity:", error);
      }
    }
  }

  connectedCallback() {
    console.log("QuickViewModal connected to the DOM");
  }

  disconnectedCallback() {
    console.log("QuickViewModal removed from the DOM");
  }
}

customElements.define("quick-view-modal", QuickViewModal);

if (typeof NotificationPopup !== 'undefined') {
  window.NotificationPopup = NotificationPopup;
}
